import {
  EditableRowsProvider,
  EditableSettingRow,
  SettingRowsCard,
} from "@/app/Settings/Settings/Components/EditableSettingRow";
import { updateIntegrationMutation } from "@/app/Settings/Settings/GraphQL/integrationMutations";
import { IntegrationRecord } from "@/app/Settings/Settings/GraphQL/integrationQueries";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { SettingCard } from "@/app/Settings/Settings/Components/SettingFormCard";
import { Click4WheelsStationLinks } from "@/app/Settings/Integrations/Click4Wheels/Click4WheelsStationLinks";
import { ActivityLogFeed } from "@/app/ActivityLogs/Components/ActivityLogFeed";
import { ModelType } from "@/gql/graphql";

export function Click4WheelsIntegrationScreen({
  integration,
}: {
  integration: IntegrationRecord;
}) {
  const { mutateAsync } = useGqlMutation(updateIntegrationMutation);
  const metadata = integration?.metadata;

  return (
    <EditableRowsProvider>
      <div className="space-y-6">
        <SettingRowsCard
          title="Sign in"
          description="The Click4Wheels agent account new bookings are placed with as soon as they go pending. Results show in each booking's activity log."
        >
          <EditableSettingRow
            label="Account"
            value={metadata?.login ?? ""}
            editClassName="max-w-2xl"
            initialValues={{
              partnerId: metadata?.partnerId ?? "",
              login: metadata?.login ?? "",
              password: metadata?.password ?? "",
            }}
            onSave={(values) =>
              mutateAsync({
                id: integration.id,
                input: {
                  metadata: { ...metadata, ...values },
                },
              })
            }
          >
            <TextInput
              name="partnerId"
              label="Partner ID"
              className="col-span-8"
            />
            <TextInput name="login" label="Login" className="col-span-8" />
            <TextInput
              name="password"
              label="Password"
              className="col-span-8"
              inputProps={{ type: "password" }}
            />
          </EditableSettingRow>
        </SettingRowsCard>
        <SettingCard
          title="Offices"
          description="The Click4Wheels station each office books from. Bookings from an unlinked office fail."
        >
          <Click4WheelsStationLinks integration={integration} />
        </SettingCard>
        <SettingCard
          title="Errors"
          description="Bookings that could not be placed in Click4Wheels. Each one needs booking by hand."
        >
          <ActivityLogFeed
            modelId={integration.id}
            modelType={ModelType.Integration}
            showComposer={false}
          />
        </SettingCard>
      </div>
    </EditableRowsProvider>
  );
}
